import { render } from "./ResourcesGoal5b.vue?vue&type=template&id=f98c5f58"
import script from "./ResourcesGoal5b.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal5b.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__